var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTailwind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 70,
    viewBox: "0 0 116 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#06b6d4",
      fillOpacity: 1
    },
    d: "M58 0C42.54 0 32.875 7.777 29.012 23.332c5.797-7.777 12.562-10.691 20.293-8.75 4.41 1.11 7.562 4.332 11.05 7.895C66.04 28.28 72.617 35 86.988 35c15.461 0 25.125-7.777 28.989-23.336-5.797 7.781-12.563 10.695-20.293 8.754-4.41-1.11-7.559-4.332-11.051-7.895C78.949 6.72 72.37 0 58 0ZM29.012 35C13.55 35 3.887 42.777.023 58.332c5.797-7.777 12.563-10.695 20.293-8.75 4.41 1.113 7.559 4.332 11.051 7.895C37.051 63.28 43.63 70 58 70c15.46 0 25.125-7.777 28.988-23.332-5.797 7.777-12.562 10.691-20.293 8.746-4.41-1.105-7.562-4.328-11.05-7.89C49.96 41.718 43.383 35 29.012 35Zm0 0"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.70db79595429640c1bd47191c8c0f915.svg";
export { ForwardRef as ReactComponent };